<template>
  <div
    class="service-card"
    :class="[serveObj.extAmount && 'reorder-container']"
  >
    <div class="card-1 card-part">
      {{ isSettlement ? serveObj.orderNo : serveObj.receiptNo }}
    </div>
    <div class="card-2 card-part">
      {{ isSettlement ? $t('components_accountcard_index_698') : serveObj.receiptKind }}
    </div>
    <div class="card-3 card-part">
      <div :class="isSettlement ? 'colorO' : amountColor ? 'colorR' : 'colorG'">
        {{ isSettlement ? `+${serveObj.deltaAmount}` : serveObj.amount }}
      </div>
    </div>
    <div class="card-4 card-part">
      <div>{{ serveObj.desc }}</div>
      <div v-if="serveObj.extAmount" class="reorder-desc">{{$t('components_accountcard_index_699', [ serveObj.extAmount ])}}</div>
    </div>
    <div class="card-5 card-part">
      {{ new Date(serveObj.createTime).$format('yyyy-MM-dd hh:mm:ss') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serveObj: Object,
    isSettlement: Boolean
  },
  created() {
    this.getColor();
  },
  data() {
    return {
      amountColor: false
    };
  },
  methods: {
    getColor() {
      var amountG = parseInt(this.serveObj.amount);
      if (amountG >= 0) {
        this.amountColor = false;
      } else {
        this.amountColor = true;
      }
    }
  }
};
</script>

<style lang="scss">
.service-card {
  .el-dialog__header {
    border-bottom: 1px solid #e0e0e0;
    padding: 20px 30px 10px 30px;
  }
  .el-dialog__body {
    box-sizing: border-box;
    padding: 30px 0;
  }
  .el-textarea {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  .el-button--primary {
    background-color: #fa006e !important;
    border: none !important;
  }
}
</style>
<style lang="scss" scoped>
.service-card {
  font-style: normal;
  font-size: 14px;
  display: flex;
  align-items: center;
  height: 50px;
  color: #666666;
  &:hover {
    background: #f6f6f6;
  }
  .colorG {
    color: #38ba7c;
  }
  .colorR {
    color: #fa6579;
  }
  .colorO {
    color: #ff891e;
  }
  .card-part {
    @include flex(center, flex-start, column);
    height: 100%;
    text-align: center;
    white-space: nowrap;
    .reorder-desc {
      margin-top: 2px;
      font-size: 12px;
      line-height: 17px;
      color: #ff8973;
    }
  }
  .card-1 {
    width: 358px;
  }
  .card-2 {
    width: 134px;
  }
  .card-3 {
    width: 134px;
  }
  .card-4 {
    width: 158px;
  }
  .card-5 {
    width: 140px;
  }
}
.reorder-container {
  height: 70px;
}
</style>
